/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BereichKopfdaten { 
    bereich_id: string;
    titel?: string;
    beschreibung?: string;
    zusatz_beschreibung?: string;
    logo_blob_id?: string;
    reihenfolge?: number;
    externe_url?: string;
    ist_trigger_liste?: boolean;
    ist_externe_url?: boolean;
}

